import { getApiHeader } from '../../../../../utlis/commonfunctions';
import React, { useEffect, useState } from 'react'
import axios from "axios";
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import AddPlanHead from '../AddPlanHead';
import CountryList from '../CountryList';
import Loader from "../loader";

        
const SERVER_URL = process.env.REACT_APP_API_URL+"add_a_mobile_plan/";

const apiUrl = process.env.NEXT_PUBLIC_API_URL;
const apiKey = process.env.NEXT_PUBLIC_API_KEY;



function Plans({nextStep, prevStep, commonSession, planDetails, handlePlanSelection, setIddCheck}) {

  const [loading, setIsLoading]                 = useState(true);
  const [reference, setReference]               = useState('');
  const [cntrList, setCntrList]                 = useState(false);
  const [planType, setPlan_type]                = useState(28);
  const [planList, setPlanList]                 = useState([]);
  const [plans, setPlans]                       = useState([]);
  const [referencePlan, setReferencePlan]       = useState(false);
  const [referencePlansStatus, setReferencePlanStatus]       = useState(false);
  const [refPlanName, setRefPlanName]           = useState(false);
  const [singlePlan, setSinglePlan]             = useState(false);
  const [selectedPlan, setSelectedPlan]         = useState('');
  const [plan_selection_type, setPlanSelectionType] = useState('default');
  const [freeCreditArray, setFreeCreditArray]   = useState([]);
  const [referenceNumberStatus,setReferenceNumberStatus]=useState(false)
  const[type,setType]=useState("");
  const[showIdd,setIdd]=useState(false);
  const [isFreeIddAvailable, setIsFreeIddAvailable] = useState(false);
 
  useEffect(() => {
    const userType = sessionStorage.getItem('userType')
    setType(userType)
  
          planFunction();
  }, [planDetails]);

  const planFunction =() =>{

    
    if(planDetails != undefined){

        if(planDetails.allplans != undefined){

          if(planDetails.allplans.planList != undefined){
            const planListArray = Object.entries(planDetails.allplans.planList);
            setPlanList(planListArray);
            
          }
          if(planDetails.allplans.plans != undefined){
            setPlans(planDetails.allplans.plans);
          }

          if(planDetails.is_credit_plan != undefined){
            if(planDetails.is_credit_plan === true){
                if(planDetails.credit_sim_plan != undefined){
                    setPlanSelectionType('credit-sim');
                    setSinglePlan(planDetails.credit_sim_plan);
                }
            }
          }


          if(planDetails.allplans.freeCredits != undefined){
            if(planDetails.allplans.freeCredits !== null){
              setFreeCreditArray(planDetails.allplans.freeCredits);
            }
          }


          setIsLoading(false);

        }

    }
  }


  const toggleCountry =(plan_id)=>{
    if(cntrList === plan_id){
      setCntrList(false);
    }else{
      setCntrList(plan_id);
    }
  }



  const handleTypeChange =(plan_type)=>{ 
   setPlan_type(plan_type);
  }


  const handleIddChange =()=>{
     setIdd((prev)=> !prev)
     setIddCheck((prev)=> !prev)
   }




  const[addedToCart,setAddedToCart]=useState({})

  const handleAddToCart =(plan_id)=>{ 

      var selectedplanType = null;
      const selectedPlan = freeCreditArray.find(plan => plan.plan_id === plan_id);
      if (selectedPlan && selectedPlan.credits > 0) {
          var selectedplanType = 'free-credit';
      }

      selectPlan(plan_id,selectedplanType);

  }



  const setReferenceNumber = (event) => {
        const value = event.target.value;
        const numericValue = value.replace(/[^0-9]/g, "");
        setReference(numericValue);
  };



  const checkReferenceNumber = async (event) => {
        event.preventDefault();

        if(reference ===null || reference ===''){
          swal("", "Please Enter Valid Reference Number", 'error');
          return;
        }

        if(reference.length < 7){
          swal("", "Please Enter Valid Reference Number", 'error');
          return;
        }

        setIsLoading(true);
        const post_data = {
            SessionId: commonSession,
            ref_number: reference
        };

        const headers=await getApiHeader();

        try {
            const response = await axios.post(`${SERVER_URL}reference_number_check`, post_data, { headers });
            var response_error = true;
            if(response.status===200){
                if(response.data.message !== 'undefined'){
                    swal(response.data.message, "", 'success');
                    var response_error = false;
                    // console.log(response.data.data.reference_plan);
                    setReferencePlanStatus(true);
                    setReferencePlan(response.data.data.reference_plan);
                    setSinglePlan(response.data.data.reference_plan);
                    setRefPlanName(response.data.data.PlanName);
                    setPlanSelectionType('reference-number');
                    setReferenceNumberStatus(true)
                }
            }

            setIsLoading(false);
            if(response_error===true){ swal("Unexpected error", "Please try again.", 'error'); }
            //nextStep();
        } catch (error) {
            setIsLoading(false);
            console.log(error);
            if(error.response.data.message != 'undefined'){
                swal("", error.response.data.message, 'warning');
            }else{
                swal("Unexpected error", "Please try again", 'error');
            }
        }
    };




    const selectPlan = async (planId,selectedplanType=null) => {

        if(selectedPlan === planId){
          return false;
        }

        //event.preventDefault();
        setIsLoading(true);
        setIsFreeIddAvailable(false);
        const post_data = {
            session_id: commonSession,
            plan_id: planId,
            plan_type: selectedplanType !== null ? selectedplanType : plan_selection_type,
            reference_number_status:referenceNumberStatus,
        };

        const headers=await getApiHeader();

        try {
            const response = await axios.post(`${SERVER_URL}select-plan`, post_data, { headers });
            var response_error = true;
            if(response.status===200){
                if(response.data.message !== 'undefined'){
                    swal("", response.data.message, 'success');
                    var response_error = false;
                    setSelectedPlan(planId);
                    //handlePlanSelection(response.data.data);
                    const apiData = response?.data?.data?.data;
                    if (!apiData) {
                      throw new Error("Invalid API response");
                    }

                    // store free_idd_60 flag
                    setIsFreeIddAvailable(apiData.free_idd_60 === true);
                    setIdd(false);
                    setIddCheck(false)
                    // pass data to parent (if needed)
                    handlePlanSelection({
                      ...response.data.data,
                      free_idd_60_selected: showIdd
                    });
                    //targetRef.current.scrollIntoView({ behavior: 'smooth' });
                }
            }

            setIsLoading(false);
            if(response_error===true){ swal("Unexpected error", "Please try again.", 'error'); }
        } catch (error) {
            setIsLoading(false);
            console.log(error);
            if(error.response.data.message != 'undefined'){
                swal("", error.response.data.message, 'warning');
            }else{
                swal("Unexpected error", "Please try again", 'error');
            }
        }
    };




    const ProceedNextStep =()=>{ 
      if(selectedPlan !=='' && selectedPlan !== null){
          nextStep({
             free_idd_60_selected: showIdd
          });
      }else{
          swal("", "Please select the plan and continue", 'warning');
      }
    }


    



  return (
    <div>
        <DashboardLayout>
         <DashboardNavbar/>
         <AddPlanHead />
            <div className="formbold-main-wrapper add-plan-wrapper">
              <div className="formbold-form-wrapper add-plan-form pos-rel">
                {loading === true && (
                    <Loader />
                )}

                <h6>Select Plan</h6>
                <hr/>

                {(plan_selection_type !== 'credit-sim') && (
                <>
                  
                  
                    <p className='plans-notes'>Note: If you have already purchased the Telsim plan from Retailer Portal or you have an activation voucher code, enter your activation voucher code or promo code here. Activation voucher code will be mentioned on the email confirmation sent to you or in the invoice. </p>
                    <form onSubmit={checkReferenceNumber} className="ad-mb-form">
                        
                        {referencePlansStatus === false ?
                        <>
                            <div className="col-lg-6">
                                <label className="formbold-form-label formbold-form-label-2">Enter Reference Number or Promo Code</label>
                                <input
                                    type="text"
                                    name="reference_number"
                                    placeholder="Enter Reference Number / Promo Code"
                                    className="formbold-form-input addInput"
                                    value={reference}
                                    onChange={setReferenceNumber}
                                    maxLength="25"
                                    keyboardType="numeric"
                                    autoComplete='off'
                                />
                                
                            </div>
                            <div className="col-lg-6 verify-account">
                                <br/>
                                <button className="button btn btn-danger ad-mb-button">Apply</button>
                            </div>
                        </>
                        :
                        <>
                          <div className="col-lg-6">
                              <label className="formbold-form-label formbold-form-label-2">Enter Reference Number or Promo Code</label>
                              <input
                                  type="text"
                                  name="reference_number"
                                  placeholder="Enter Reference Number / Promo Code"
                                  className="formbold-form-input addInput readonly"
                                  value={reference}

                              />
                              <span className="ad-mp-succ">Reference Number verified, Plan: {refPlanName}</span>
                          </div>
                          
                        </>
                        }


                    </form>
                  
                 
   
                  <br/>


                    
                  {(freeCreditArray !== null && freeCreditArray.length > 0) ?
                  <>
                    <h6>Credit Balance</h6>
              
                    <div className="container-fluid mt-4" id="credit-tab-section">
                        
                        <ul className="nav nav-tabs" style={{ backgroundColor: "#fff" }}>

                          {freeCreditArray.map(fcredit =>( 
                              <li className="nav-item">Telsim {fcredit.sell_amount < fcredit.plan_amount ? (<><b style={{ textDecoration: "line-through" }}>${Number(fcredit.plan_amount).toFixed(2)}</b>&nbsp;${Number(fcredit.sell_amount).toFixed(2)}</>) : (<> ${Number(fcredit.plan_amount).toFixed(2)} </>)} Prepaid Pack 
                              <span><>You have <b>{fcredit.port_in_credits}</b> credits remaining for Port-Ins</>  </span>

                                <span>
                                    {fcredit.credits === 0 ? (
                                         type !=="PAR"?
                                        <>You get <b>{fcredit.percenatage}%</b> discounts on new activations</>
                                       :
                                      
                                      "You have exceeded your free limit. Please make a payment to proceed with the new activation."

                                    ) : (
                                      <>You have <b>{fcredit.credits}</b> credits remaining for new Activations</>
                                    )}
                                </span>
                              </li>
                            ))}
                          
                        </ul>
                    </div>
                  </>
                  : null }


                </>
                )}


                {(plan_selection_type === 'credit-sim') && (
                  <p className="ad-mp-succ"><i className="fa fa-check"></i> Credit SIM Verified</p>
                )}

                <br/>

                <h6 className="psyp-mr-btm">Please select your plan</h6>
                {
                     type !=="PAR" ?
                    <p className='plans-notes'>Note:Discounts are applied only at checkout.</p>
                    :""
                 }


                {singlePlan === false ?
                <>
            
                <div className="container-fluid mt-4" id="plan-tab-section">

                    <section className="country-listing">
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 country-tab">
                          <div className="row">
                            <div className="col-md-12 tab-button">
                              <ul className="nav nav-tabs" style={{ backgroundColor: "#fff" }}>

                                {planList.map(([key, value]) => (
                                   <li className={" " + (planType == key ? 'activeplantab' : '')}  onClick={() => handleTypeChange(key)}>
                                        <span className={""}>
                                          {value}
                                        </span>
                                    </li>  
                                ))}

                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <br />
                    </section>

                </div>

                </>
                :
                null
                }



                <div className='row add-mb-plans'>

                      {plans.map(plan => (
                        <>
                          
                            {( (singlePlan === false && planType == plan.plan_type) || (singlePlan !== false && plan.plan_id == singlePlan) ) && (

                              <div className='col-lg-3' key={plan.plan_id}>
                                <div className='add-plan-card'>

                                {
                                  plan.sell_amount < plan.amount ? (
                                    <p className="plan-cards-head">
                                      {plan.total_data}GB Data -
                                      <span style={{ textDecoration: "line-through" }}>
                                        ${plan.amount}
                                      </span>
                                      &nbsp;${plan.sell_amount}
                                    </p>
                                  ) : (
                                    <p className="plan-cards-head">
                                      {plan.total_data}GB Data - ${plan.amount}
                                    </p>
                                  )
                                }

                                      <p className="plan-cards-validity">{plan.validity} Days Expiry</p>

                                      {plan.plan_tag !== null && (
                                        <span className="plan-cards-tag">{plan.plan_tag}</span>
                                      )}

                                      <ul className='plan-cards-details'>
                                        <li>{plan.data}GB &nbsp;
                                        {plan.bonus_data > 0 &&(
                                          <>
                                           + {plan.bonus_data}GB Bonus &nbsp;
                                          </>
                                        )}
                                        Data</li>
                                        {plan.activation_plan_descriptions.map(desc => (
                                          <li key={desc.plan_id}>{desc.description}</li>
                                        ))}
                                      </ul>


                                      {plan.countries ?
                                      <>

                                        <p className="plan-cards-country" onClick={() => toggleCountry(plan.plan_id)}>
                                          <i className={"fa " + (cntrList == plan.plan_id ? 'fa-chevron-up' : 'fa-chevron-down')} ></i> Country List
                                        </p>



                                        {cntrList == plan.plan_id && (
                                          <div className="contry-list">
                                             <CountryList  countryData={plan.countries} /> 
                                          </div>
                                        )}

                                      </>
                                      : 

                                      <p className="plan-cards-country">&nbsp;</p> }

                                      <div className='text-center select-btn'>
                                          <button className='cart-button' onClick={() => handleAddToCart(plan.plan_id)}>
                                            {selectedPlan === plan.plan_id ?
                                            <>
                                              <i className="fa fa-check"></i> Selected Plan
                                            </>
                                            :
                                            <>
                                              Select Plan
                                            </>
                                            }
                                          </button>
                                      </div>

                                      <a className="plan-cards-cis" href="https://www.telsim.com.au/critical-information-summary" target="_blank">Critical Information Summary</a>

                                </div>
                              </div>

                            )}
                        </>
                      ))} 
                </div>

                {isFreeIddAvailable && (
                <div className="promotional-offer">
                  <label class="checkbox-label">
                    <input type="checkbox" class="checkbox-input" checked={showIdd} onChange={handleIddChange} />
                    <span class="checkbox-text"><b>Get Exclusive IDD Offer:</b> Get FREE 60 minutes of international calls to <b>Sri Lanka, Nepal, Pakistan, Philippines,</b> Bhutan, Brunei, Cambodia, Iran, Iraq, Laos, Mongolia, Nigeria, South Africa, Turkey & Vietnam on every plan recharge. T&C Apply.</span>
                  </label>
                </div>
                )}
          
               

                <br/>
                <br/>
                <div className="button-container add-mb-button-container">
                    <button className="button btn btn-danger" onClick={prevStep}>
                        Back
                    </button>

                    <button className="button btn btn-danger ad-mb-button-next" onClick={ProceedNextStep}>
                        Next
                    </button>
                </div>

              </div>
            </div>
      </DashboardLayout>
    </div>
  )
}

export default Plans